import React from 'react'
import { render } from 'react-dom'
import FloorPlanScaler from '../FloorPlanScaler'

class Overlay extends google.maps.OverlayView {
  constructor({ map, adjacentDistance, center }) {
    super()
    this.map = map
    this.floorPlanProps = { adjacentDistance, center }
    this.setMap(this.map)
  }

  getDistance() {
    return google.maps.geometry.spherical.computeDistanceBetween(this.left.getPosition(), this.right.getPosition())
  }

  getHeading() {
    return google.maps.geometry.spherical.computeHeading(this.left.getPosition(), this.right.getPosition())
  }

  getCenter() {
    return google.maps.geometry.spherical.computeOffset(this.left.getPosition(), this.getDistance() / 2, this.getHeading())
  }

  onAdd() {
    const { floorPlanProps } = this

    let distance = floorPlanProps.adjacentDistance / 3
    let overlayProjection = this.getProjection()
    let centerPx = overlayProjection.fromLatLngToDivPixel(floorPlanProps.center)
    centerPx.y = centerPx.y - 100
    let centerLatLng = overlayProjection.fromDivPixelToLatLng(centerPx)

    let p1 = google.maps.geometry.spherical.computeOffset(centerLatLng, distance / 2, -90)
    let p2 = google.maps.geometry.spherical.computeOffset(centerLatLng, distance / 2, 90)

    this.line = new google.maps.Polyline({
      map: this.map,
      path: [p1, p2],
      strokeWidth: 2,
      strokeColor: '#4CE91C',
      draggable: true,
      zIndex: 102
    })

    const markerOptions = {
      map: this.map,
      draggable: true,
      raiseOnDrag: false,
      zIndex: 102,
      icon: {
        path: 'M9.35,32.8V3 M0,3h18.7 M18.7,32.8H0',
        anchor: new google.maps.Point(9, 17.9),
        scale: 0.7,
        strokeWeight: 2.6,
        strokeColor: '#19B600',
        rotation: 0
      }
    }

    this.left = new google.maps.Marker(Object.assign({}, markerOptions, { position: p1 }))
    this.right = new google.maps.Marker(Object.assign({}, markerOptions, { position: p2 }))
    google.maps.event.addListener(this.left, 'drag', e => {
      this.line.setPath([this.right.getPosition(), e.latLng])
      return this.draw()
    }
    )
    google.maps.event.addListener(this.right, 'drag', e => {
      this.line.setPath([this.left.getPosition(), e.latLng])
      return this.draw()
    }
    )
    google.maps.event.addListener(this.line, 'drag', e => {
      this.left.setPosition(this.line.getPath().getArray()[0])
      this.right.setPosition(this.line.getPath().getArray()[1])
      return this.draw()
    }
    )
  }

  draw() {
    // update rotation
    const angle = google.maps.geometry.spherical.computeHeading(this.left.getPosition(), this.right.getPosition())
    this.left.setIcon({...this.left.getIcon(), rotation: angle - 90})
    this.right.setIcon({...this.right.getIcon(), rotation: angle - 90})
  }

  onRemove() {
    const elements = [this.line, this.left, this.right]
    elements.forEach(el => el.setMap(null))
  }
}

export default Overlay



// WEBPACK FOOTER //
// ./src/components/FloorPlan/FloorPlanScalerOverlay/index.js